import { useState } from 'react';

import { Restaurant, RestaurantService } from '../../../interfaces';
import { Button } from '@material-tailwind/react';
import { MdCreate } from 'react-icons/md';
import RestaurantInputCard from '../InputComponents/RestaurantInputCard';

const EditPropertyInputCard = (props: {
  restaurantService: RestaurantService;
  saveChangesToExistingCompanyService: any;
}) => {
  const [editedRestaurant, setEditedRestaurant] = useState<Restaurant | null>(null);
  const [isButtonFloating, setIsButtonFloating] = useState<boolean>(false);

  /**
   * Function can add the edited restaurant to map, with the locationId as the key, or remove the key-value if there is no change
   * to the restaurant
   * Note: 'restaurantId' is not used because there can only be editing of 1 restaurant in this component. However this function is structured
   * to take in the same set of parameters as the props of LocationInputCard component so as to reduce the number of props for the RestaurantInputCard component.
   * @param idParameters - Object containing restaurantId of the restaurant
   * @param editedRestaurant - Restaurant object containing the edited attribute of an existing retaurant, or undefined if the retaurant is to be removed
   */
  const updateEditedRestaurant = (
    idParameters: { restaurantId: number },
    editedRestaurant?: Restaurant
  ) => {
    if (editedRestaurant) {
      setEditedRestaurant(editedRestaurant);
    } else {
      setEditedRestaurant(null);
    }
  };

  /**
   * Function is run by save changes button, and calls saveChangesToExistingCompanyService function that is
   * passed down from parent CompanyCard component. Function saves edited retaurant (if any).
   */
  const saveChangesForUpdateRestaurantOnClick = async () => {
    const isSaved = await props.saveChangesToExistingCompanyService(
      {
        companyId: props.restaurantService.companyId,
        restaurantId: props.restaurantService.restaurantId,
      },
      {},
      {
        restaurantToBeUpdated: editedRestaurant !== null ? editedRestaurant : undefined,
      }
    );
    // Reset changes if the restaurant changes have been updated successfully
    if (isSaved) {
      setEditedRestaurant(null);
    }
  };

  return (
    <div className="flex flex-col">
      <Button
        onClick={saveChangesForUpdateRestaurantOnClick}
        size="sm"
        color="green"
        className={`${
          isButtonFloating && 'fixed top-20 z-10'
        } SaveChangesButton bg-blue-600 w-fit self-end flex gap-x-1 pt-2 p-2 font-medium h-fit'}`}
      >
        <MdCreate className="self-center" />
        Save Changes
      </Button>
      <RestaurantInputCard
        arrNewRestaurant={[]}
        companyId={props.restaurantService.companyId}
        restaurantId={props.restaurantService.restaurantId}
        restaurantService={props.restaurantService}
        updateRestaurant={updateEditedRestaurant}
      />
    </div>
  );
};

export default EditPropertyInputCard;
